import qcWxFrame from './qcWxFrame';
import qqConnectFrame from './qqConnectFrame';
import qqFrame from './qqFrame';
import qqWxFrame from './qqWxFrame';
import wegameFrame from './wegameFrame';
import wxFrame from './wxFrame';
import mQQWxFrame from './mQQWxFrame';
export default {
  qcWxFrame: qcWxFrame,
  qqConnectFrame: qqConnectFrame,
  qqFrame: qqFrame,
  qqWxFrame: qqWxFrame,
  wegameFrame: wegameFrame,
  wxFrame: wxFrame,
  mQQWxFrame: mQQWxFrame
};